/**
 * `cancelOrder`, the SPA's one LOP write and the only cancellation the protocol
 * knows: the backend's DELETE leaves the signature fillable. The traits must be
 * the order's own, verbatim: `MakerTraitsLib.useBitInvalidator` reads them to
 * pick which invalidator to bump.
 */

import { encodeFunctionData, parseAbi, type Hex } from "viem";
import { sendTransaction } from "./wallet";

export const LOP_CANCEL_ABI = parseAbi([
  "function cancelOrder(uint256 makerTraits, bytes32 orderHash)",
]);

/** `cancelOrder(uint256,bytes32)` calldata for one order. */
export function encodeCancelOrder(makerTraits: string | bigint, orderHash: string): Hex {
  return encodeFunctionData({
    abi: LOP_CANCEL_ABI,
    functionName: "cancelOrder",
    args: [typeof makerTraits === "bigint" ? makerTraits : BigInt(makerTraits), orderHash as Hex],
  });
}

/**
 * Resolves with the hash and throws every failure, 4001 included: a rejection
 * and a fault mean opposite things for the backend's copy of the order.
 */
export function sendCancelOrder(params: {
  maker: string;
  lopAddress: string;
  makerTraits: string | bigint;
  orderHash: string;
}): Promise<Hex> {
  return sendTransaction({
    from: params.maker,
    to: params.lopAddress,
    data: encodeCancelOrder(params.makerTraits, params.orderHash),
  });
}
